import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import DOMPurify from 'dompurify';
import './Application.css';
import publicAxios from '../../utils/axios/publicAxios';
import moment from 'moment';

const Application = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [application, setApplication] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchApplication = async () => {
      try {
        const response = await publicAxios.get(`/public/application/${id}`);
        setApplication(response.data.form);
      } catch (error) {
        console.error('Error fetching application', error);
      } finally {
        setLoading(false);
      }
    };

    fetchApplication();
  }, [id]);

  if (loading) return <div className="application-loading">Loading...</div>;

  if (!application) return <div className="application-error">Application not found.</div>;

  return (
    <div className="application">
      <div className="application-header">
        <h1>{application.title}</h1>
        {application.imageUrl && <img src={application.imageUrl} alt={application.title} className="application-image" />}
        <p className="application-meta">
          By: {application.createdBy?.firstname} {application.createdBy?.lastname} | Created: {moment(application.createdAt).format('MMMM DD, YYYY')}
          {application.updatedAt && ` | Last Edited: ${moment(application.updatedAt).format('MMMM DD, YYYY')}`}
        </p>
      </div>

      <div
        className="application-content"
        dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(application.description) }}
      ></div>

      <div className="application-actions">
        <button onClick={() => navigate('/applications')}>Back to Applications</button>
        <button onClick={() => navigate(`/submit-form/${application._id}`)}>Apply</button>
      </div>
    </div>
  );
};

export default Application;